import React, { useRef, useState, useEffect } from 'react'
import { IonButton, IonCard, IonChip, IonContent, IonGrid, IonIcon, IonItem, IonLabel, IonLoading, IonModal, IonRow, IonSelect, IonSelectOption, isPlatform } from '@ionic/react'
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab';
import CalendarSync from '../../services/CalendarSync';
import { CalendarInterface } from '../../components/WalkCalendar';
import { Calendar as CalendarComp } from '@ionic-native/calendar'
import dayjs from 'dayjs';
import Api from '../../services/Api';
import { useDispatch, useSelector } from 'react-redux';
import { openAlert } from '../../redux/actions/alertActions';
import { syncCircle } from 'ionicons/icons';
import { RootState } from '../../redux/reducers';
import { WalkI } from '../../interfaces/Walk';
import { HourInterface } from '../../components/Walk/DayTimeline';
import TimelineComponent from '../../components/Walk/TimelineComponent';

interface CalendarState {
  selectedCalendar: number
  calendars: Array<CalendarInterface>
  gotCalendars: boolean
  setCalendar: number
  isOpen: boolean
}

interface ComponentProps {
  day: string | undefined | null
  setTimePicker: Function
  end: any
  openSync: boolean
  closeSync: Function
}

const CreateCalendarPickerTimeline = ({ day, setTimePicker, end, openSync, closeSync }: ComponentProps) => {
  const api = Api.getInstance();
  const localStorageCal = CalendarSync.getInstance()
  const scrollRef = useRef<any>(null)
  const myRef = useRef(null)
  const dispatch = useDispatch()
  const walks = useSelector((state: RootState) => state.walks.walks)

  const [calendarSync, setCalendarSync] = useState<CalendarState>({
    selectedCalendar: 0,
    calendars: [],
    gotCalendars: false,
    setCalendar: window.localStorage.Calendar_id,
    isOpen: false
  })
  const [events, setEvents] = useState<Array<any>>([])
  const [walk, setWalk] = useState<Array<WalkI>>([])
  const [hours, setHours] = useState<HourInterface[]>([])

  useEffect(() => {
    if(myRef.current !== null) {
      scrollTo(myRef)
    }
  }, [hours])

  useEffect(() => {
    localStorageCal.fetchLocally()
    localStorageCal.storeLocally()

    setCalendarSync({
      ...calendarSync, 
      setCalendar: window.localStorage.Calendar_id 
    })
  }, [])

  useEffect(() => {
    getWalkOnDay()
    setDay()
  }, [day])

  useEffect(() => {
    localStorageCal.setCalendar(calendarSync.setCalendar)
  }, [calendarSync.setCalendar])

  const getWalkOnDay = () => {
    setWalk(walks.filter((walk: WalkI) => dayjs(walk.start).format('YYYY-MM-DD') === dayjs(day).format('YYYY-MM-DD')))
  }

  const getEvents = () => {
    let start = dayjs(day).toDate()
    let end = dayjs(day).toDate()
    let newArr: Array<any> = []
  
    if(isPlatform('android')) {
      if(calendarSync.calendars.length > 0) {
        CalendarComp.listEventsInRange(start, end).then(events => {
          for(const ev of events){
            if(ev.calendar_id === calendarSync.setCalendar) {
              newArr.push(ev)
            }
          }
          setEvents(newArr)
        }).catch(error => {
          console.error(error.message);
        })
      }
    } else if (isPlatform('ios')){
      if(calendarSync.calendars.length > 0 && calendarSync.setCalendar) {
        const calName = calendarSync.calendars.filter(cal => cal.id === calendarSync.setCalendar)
        if(calName.length > 0){
          CalendarComp.findAllEventsInNamedCalendar(calName[0].name).then(events => {    
            for(const ev of events){
              newArr.push(ev)
            }
            setEvents(newArr)
          }).catch(error => {
            console.error('error:', error.message);
          })
        }
      }
    }
  }

  const listCalendars = () => {
    CalendarComp.listCalendars().then((cals: Array<any>) => {
      const calendars: Array<CalendarInterface> = [];
      for (const cal of cals) {
        if (isPlatform('android')) {
          if (cal.isPrimary) {
            calendars.push(cal);
          }
        } else {
          if (cal.name !== 'Birthdays') {
            calendars.push(cal)
          }
        }
      }
      setCalendarSync({
        ...calendarSync, 
        calendars: calendars, 
        gotCalendars: true,
        setCalendar: window.localStorage.Calendar_id
      })
    })
  }

  const handleCalendarSync = (e: any) => {
    setCalendarSync((prevState) => {
      return {
        ...prevState,
        setCalendar: e.target.value
      }
    })
  }

  const setDay = () => {
    let arr = [] 
    for(let i = 0; i < 24; i++) {
      const walks = walk.filter(hour => parseInt(dayjs(hour.start).format('H')) === i)
      const calSync = events.filter(ev => {
        if(dayjs(ev.dtstart).format('YYYY-MM-DD') === dayjs(day).format('YYYY-MM-DD')) {
          return parseInt(dayjs(ev.dtstart).format('H')) === i
        }
      })

      const hour = {
        hour: i,
        walks: walks,
        events: calSync
      }
      arr.push(hour)
    }
    setHours(arr)
  }

  const scrollTo = (ref: any) => {
    scrollRef.current.scrollToPoint(0, ref.current.offsetTop - 200)
  }

  return (
    <IonContent fullscreen scrollEvents ref={scrollRef} className="fullWidth">
      { hours.map((hour, index) => {
        if(hour.hour === parseInt(dayjs(day).format('H'))) {
          return <Timeline key={index} 
          ref={myRef}
          >
            <TimelineItem className="fullWidth"> 
              <TimelineSeparator>
                <IonChip class="p-2" color="teal">
                {parseInt(dayjs(day).format('H'))}
                </IonChip>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <IonCard className="p-2">
                  <IonGrid>
                    <IonRow>
                      {dayjs(day).format('HH.mm')} - {dayjs(end).format('HH.mm')}
                    </IonRow>
                    <IonRow>
                      <h2>Ny promenad</h2>
                    </IonRow>
                  </IonGrid>
                </IonCard>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        }
        return <article 
        className="fullWidth"
        key={index}>
          <TimelineComponent 
            calendars={calendarSync.calendars}
            hour={hour} 
            selectedDay={dayjs(day).toDate()} 
            events={hour.events}
            setCal={calendarSync.setCalendar}
            create={true}
            setTimePicker={setTimePicker}
            />
        </article>
      })}

      <IonModal isOpen={openSync} onDidDismiss={() => closeSync()} className="modal_small">
      { !calendarSync.gotCalendars ?
        <IonLoading 
          isOpen={!calendarSync.gotCalendars}
          message={'Please wait...'}
          duration={200}/> 
        :
        <IonGrid class="p-2 flex justify-end items-center">
          <IonItem
            className="selectWrapper selectWrapper--modal fullWidth"
            onClick={() => {
              if(calendarSync.gotCalendars) {
                setCalendarSync({...calendarSync, isOpen: true})
              } else {
                dispatch(openAlert({
                  header: 'Felmeddelande',
                  message: 'Kunde inte hitta några kalendrar'
                }))
              }
            }}
            >
            <IonLabel class="mr-2 flex items-center">{api.tr('calendar')}
            </IonLabel>
            <IonSelect 
              interface="action-sheet"
              value={calendarSync.setCalendar}
              onIonChange={handleCalendarSync}
              cancelText={api.tr('close')} okText={api.tr('choose')}>
                <IonSelectOption value={0}>Rensa val</IonSelectOption>
                { calendarSync.calendars.map(calendar => {
                  // console.log(calendar)
                  return <IonSelectOption key={'calendar'} value={calendar.id}>
                    { calendar.name }
                  </IonSelectOption>
                  })}
            </IonSelect>
          </IonItem>
          { calendarSync.setCalendar !== 0 ? 
          <IonButton fill="clear" onClick={() => {
            getEvents()
          }}>
            <IonIcon icon={syncCircle} size="large" color="primary" class="ml-2"/>
          </IonButton>
          : null }
        </IonGrid>
      }

      </IonModal>
    </IonContent>
  )
}

export default CreateCalendarPickerTimeline